(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["eb-cart-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('eb-cart-tools')) {
  customElements.define('eb-cart-tools', class extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.eb-cart-paybar');
      this.total = this.querySelector('[data-eb-cart-total]');
      this.button = this.querySelector('[data-eb-cart-checkout]');
      this.schedule = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      };
      this.checkout = () => {
        const nativeButton = document.getElementById('checkout');
        if (!nativeButton || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true') return;
        if (document.querySelector('.cart__items--disabled')) return;
        nativeButton.click();
      };
      this.button.addEventListener('click', this.checkout);
      this.observer = new MutationObserver(this.schedule);
      const content = document.getElementById('MainContent');
      if (content) this.observer.observe(content, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      window.addEventListener('scroll', this.schedule, { passive: true });
      window.addEventListener('resize', this.schedule);
      this.update();
    }
    update() {
      const nativeButton = document.getElementById('checkout');
      const footer = document.getElementById('main-cart-footer');
      const total = footer?.querySelector('.totals__total-value')?.textContent.trim() || '';
      const filled = !!document.querySelector('#cart .cart-item') && !footer?.classList.contains('is-empty');
      const active = matchMedia('(max-width: 749px)').matches && filled && !!nativeButton && !!total;
      const activeText = String(active);
      if (this.dataset.active !== activeText) this.dataset.active = activeText;
      const rect = nativeButton?.getBoundingClientRect();
      const nativeVisible = rect && rect.height > 0 && rect.top >= 0 && rect.bottom <= window.innerHeight;
      const modalOpen = !!document.querySelector('dialog[open], .quick-add-modal[open], header-drawer details[open]');
      const hidden = !active || !!nativeVisible || modalOpen;
      if (this.bar.hidden !== hidden) this.bar.hidden = hidden;
      if (this.total.textContent !== total) this.total.textContent = total;
      const disabled = !active || nativeButton.disabled || nativeButton.getAttribute('aria-disabled') === 'true' || !!document.querySelector('.cart__items--disabled');
      if (this.button.disabled !== disabled) this.button.disabled = disabled;
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      window.removeEventListener('scroll', this.schedule);
      window.removeEventListener('resize', this.schedule);
      this.button?.removeEventListener('click', this.checkout);
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["eb-navigation"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') { document.querySelectorAll('.eb-mobile-menu[open], .eb-nav-dropdown[open]').forEach(menu => menu.open = false); } });
document.addEventListener('click', (event) => { document.querySelectorAll('.eb-mobile-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; }); });
  } catch(e) { console.error(e); }
})();

})();
